import React from "react";
import AddUser from "./AddUser";

export default function AddSpecialAccessUser(props){
   return <AddUser {...props} hideAdmin={true} isSpecial={true} />
}